import { Link } from "wouter";

const PARTNER_LINKS = [
  { href: "/partners/lenders", label: "Lenders" },
  { href: "/partners/wholesalers", label: "Wholesalers" },
  { href: "/partners/brokers", label: "Brokers" },
  { href: "/partners/realtors", label: "Realtors" },
];

export function PartnerFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-slate-100 py-8 px-4 text-center text-sm text-slate-400">
      <p className="mb-2">
        {PARTNER_LINKS.map((link, i) => (
          <span key={link.href}>
            <Link href={link.href} className="hover:text-slate-600" data-testid={`link-footer-${link.label.toLowerCase()}`}>
              {link.label}
            </Link>
            {i < PARTNER_LINKS.length - 1 ? " · " : ""}
          </span>
        ))}
      </p>
      <p>
        © {year} PadPulse ·{" "}
        <Link href="/privacy" className="hover:text-slate-600" data-testid="link-footer-privacy">
          Privacy
        </Link>{" "}
        ·{" "}
        <Link href="/terms" className="hover:text-slate-600" data-testid="link-footer-terms">
          Terms
        </Link>
      </p>
    </footer>
  );
}
